<script>
import DashboardLayout from "../layouts/DashboardLayout.vue";
import LeadSourceMap from "../components/LeadSourceMap.vue";
import VueApexCharts from "vue3-apexcharts";

export default {
    name: "DashboardView",
    components: {
        DashboardLayout,
        LeadSourceMap,
        apexchart: VueApexCharts,
    },
    data() {
        return {
            selectedPeriod: "30days",
            periods: [
                {label: "7 Days", value: "7days"},
                {label: "30 Days", value: "30days"},
                {label: "90 Days", value: "90days"},
            ],
            allPeriodData: {
                "7days": {
                    performanceCards: [
                        {label: "Total conversations", value: "183", note: "+12% vs previous period", tone: "success"},
                        {label: "Leads generated", value: "42", note: "+8% vs previous period", tone: "success"},
                        {label: "Lead rate", value: "23%", note: "of conversations to lead", tone: "info"},
                        {label: "Unanswered questions", value: "8", note: "+2 vs last period", tone: "danger"},
                    ],
                    leadDistribution: [
                        {label: "Hot (75-100)", value: 3, percent: 14, tone: "danger"},
                        {label: "Warm (50-74)", value: 7, percent: 33, tone: "warning"},
                        {label: "Cold (0-49)", value: 12, percent: 57, tone: "info"},
                    ],
                    enrollmentCards: [
                        {label: "Total enrollments", value: "4", note: "Previous period: 3"},
                        {label: "Lead → enrollment rate", value: "9.5%", note: "Previous period: 7.1%"},
                        {label: "Avg. days to enroll", value: "6.2 days", note: "Previous period: 8.4 days"},
                    ],
                    conversationSeries: [
                        {name: "Conversations", data: [24, 31, 28, 35, 29, 18, 14]},
                        {name: "Leads", data: [6, 8, 7, 9, 7, 4, 3]},
                        {name: "Enrollments", data: [0, 1, 1, 1, 1, 0, 0]},
                    ],
                    conversationCategories: ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"],
                    topQuestions: [
                        {label: "Programs & pricing details?", value: 52},
                        {label: "How do I apply?", value: 38},
                        {label: "Accommodation options?", value: 29},
                        {label: "How does the visa process work?", value: 24},
                        {label: "IELTS preparation program?", value: 18},
                    ],
                    attentionItems: [
                        {title: "4 hot leads awaiting follow-up", description: "Highest score: 88 - no contact for 1 day", tone: "danger"},
                        {title: "4 enrollments this week", description: "On track for monthly record", tone: "success"},
                        {title: "Price list updated 47 days ago", description: "Chatbot may be using outdated prices", tone: "warning"},
                        {title: "IELTS questions up 40% this week", description: "Add IELTS content to knowledge base", tone: "info"},
                        {title: "8 unanswered questions this period", description: "Review knowledge base entries", tone: "danger"},
                    ],
                },
                "30days": {
                    performanceCards: [
                        {label: "Total conversations", value: "1,247", note: "+34% vs previous period", tone: "success"},
                        {label: "Leads generated", value: "312", note: "+22% vs previous period", tone: "success"},
                        {label: "Lead rate", value: "25%", note: "of conversations to lead", tone: "info"},
                        {label: "Unanswered questions", value: "47", note: "+19 vs last period", tone: "danger"},
                    ],
                    leadDistribution: [
                        {label: "Hot (75-100)", value: 12, percent: 16, tone: "danger"},
                        {label: "Warm (50-74)", value: 22, percent: 31, tone: "warning"},
                        {label: "Cold (0-49)", value: 38, percent: 53, tone: "info"},
                    ],
                    enrollmentCards: [
                        {label: "Total enrollments", value: "19", note: "Previous period: 12"},
                        {label: "Lead → enrollment rate", value: "6.1%", note: "Previous period: 4.2%"},
                        {label: "Avg. days to enroll", value: "8.4 days", note: "Previous period: 12.1 days"},
                    ],
                    conversationSeries: [
                        {name: "Conversations", data: [32, 38, 44, 41, 53, 49, 65, 73, 47, 58, 68, 77, 72, 69, 75, 83, 71, 66, 74, 79, 76, 85, 91, 95]},
                        {name: "Leads", data: [10, 13, 14, 16, 17, 14, 18, 21, 15, 18, 20, 23, 19, 22, 21, 24, 23, 25, 22, 24, 23, 26, 25, 28]},
                        {name: "Enrollments", data: [1, 1, 1, 2, 2, 1, 2, 3, 2, 3, 3, 4, 3, 3, 4, 5, 4, 4, 5, 5, 4, 6, 5, 6]},
                    ],
                    conversationCategories: Array.from({length: 24}, (_, i) => String(i + 1)),
                    topQuestions: [
                        {label: "Programs & pricing details?", value: 312},
                        {label: "How do I apply?", value: 243},
                        {label: "How does the visa process work?", value: 190},
                        {label: "Accommodation options?", value: 163},
                        {label: "IELTS preparation program?", value: 120},
                    ],
                    attentionItems: [
                        {title: "23 hot leads awaiting follow-up", description: "Highest score: 91 - no contact for 2 days", tone: "danger"},
                        {title: "19 enrollments this month - record!", description: "58% above previous month", tone: "success"},
                        {title: "Price list updated 47 days ago", description: "Chatbot may be using outdated prices", tone: "warning"},
                        {title: "IELTS questions up 40% this week", description: "Add IELTS content to knowledge base", tone: "info"},
                        {title: "47 unanswered questions this period", description: "Up from 28 last week - review knowledge base", tone: "danger"},
                    ],
                },
                "90days": {
                    performanceCards: [
                        {label: "Total conversations", value: "3,892", note: "+28% vs previous period", tone: "success"},
                        {label: "Leads generated", value: "891", note: "+31% vs previous period", tone: "success"},
                        {label: "Lead rate", value: "22.9%", note: "of conversations to lead", tone: "info"},
                        {label: "Unanswered questions", value: "132", note: "+44 vs last period", tone: "danger"},
                    ],
                    leadDistribution: [
                        {label: "Hot (75-100)", value: 38, percent: 18, tone: "danger"},
                        {label: "Warm (50-74)", value: 71, percent: 33, tone: "warning"},
                        {label: "Cold (0-49)", value: 104, percent: 49, tone: "info"},
                    ],
                    enrollmentCards: [
                        {label: "Total enrollments", value: "54", note: "Previous period: 38"},
                        {label: "Lead → enrollment rate", value: "6.1%", note: "Previous period: 5.4%"},
                        {label: "Avg. days to enroll", value: "9.1 days", note: "Previous period: 11.3 days"},
                    ],
                    conversationSeries: [
                        {name: "Conversations", data: [210, 245, 268, 290, 310, 285, 330, 355, 370, 390, 410, 425, 445]},
                        {name: "Leads", data: [52, 58, 64, 72, 78, 68, 82, 91, 95, 101, 108, 114, 118]},
                        {name: "Enrollments", data: [3, 4, 5, 6, 7, 5, 7, 8, 9, 10, 11, 12, 13]},
                    ],
                    conversationCategories: ["W1", "W2", "W3", "W4", "W5", "W6", "W7", "W8", "W9", "W10", "W11", "W12", "W13"],
                    topQuestions: [
                        {label: "Programs & pricing details?", value: 891},
                        {label: "How do I apply?", value: 712},
                        {label: "How does the visa process work?", value: 548},
                        {label: "Accommodation options?", value: 461},
                        {label: "IELTS preparation program?", value: 334},
                    ],
                    attentionItems: [
                        {title: "67 hot leads awaiting follow-up", description: "Average wait time: 3.2 days", tone: "danger"},
                        {title: "54 enrollments this quarter", description: "42% above previous quarter", tone: "success"},
                        {title: "Price list updated 47 days ago", description: "Chatbot may be using outdated prices", tone: "warning"},
                        {title: "IELTS query volume trending up", description: "Consistent growth over 12 weeks", tone: "info"},
                        {title: "132 unanswered questions this period", description: "Significant knowledge gap detected", tone: "danger"},
                    ],
                },
            },
            enrollmentTrendSeries: [
                {
                    name: "Enrollments",
                    data: [8, 10, 14, 22, 18, 12, 9, 11, 13, 16, 14, 19],
                },
            ],
            enrollmentTrendOptions: {
                chart: {
                    type: "bar",
                    toolbar: {show: false},
                },
                colors: ["#0d9488"],
                plotOptions: {
                    bar: {
                        borderRadius: 4,
                        columnWidth: "62%",
                    },
                },
                grid: {
                    borderColor: "#eef2f7",
                    strokeDashArray: 2,
                },
                xaxis: {
                    categories: ["Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec", "Jan", "Feb", "Mar", "Apr", "May"],
                    axisBorder: {show: false},
                    axisTicks: {show: false},
                },
                yaxis: {
                    min: 0,
                    max: 25,
                    tickAmount: 5,
                },
                dataLabels: {enabled: false},
                legend: {show: false},
                tooltip: {enabled: true},
            },
            mapBubbles: [
                {country: "USA", code: "US", value: 45, lng: -98.5795, lat: 39.8283, size: "sm"},
                {country: "Mexico", code: "MX", value: 89, lng: -102.5528, lat: 23.6345, size: "md"},
                {country: "Brazil", code: "BR", value: 312, lng: -51.9253, lat: -14.235, size: "xl"},
                {country: "Spain", code: "ES", value: 67, lng: -3.7492, lat: 40.4637, size: "md"},
                {country: "Japan", code: "JP", value: 98, lng: 138.2529, lat: 36.2048, size: "lg"},
                {country: "South Korea", code: "KR", value: 87, lng: 127.7669, lat: 35.9078, size: "lg"},
                {country: "Sweden", code: "SE", value: 67, lng: 18.6435, lat: 60.1282, size: "md"},
            ],
            heatmapRows: [
                {day: "Mon", values: [2, 2, 2, 3, 3, 2, 1, 1, 2, 3, 4, 5, 6, 7, 7, 6, 5, 4, 3, 3, 2, 2, 1, 1]},
                {day: "Tue", values: [2, 2, 3, 3, 2, 2, 1, 1, 2, 3, 5, 6, 7, 8, 8, 7, 6, 5, 4, 3, 3, 2, 2, 1]},
                {day: "Wed", values: [2, 2, 2, 3, 2, 2, 1, 1, 2, 3, 4, 6, 7, 7, 7, 6, 5, 4, 4, 3, 3, 2, 2, 1]},
                {day: "Thu", values: [2, 2, 2, 2, 2, 2, 1, 1, 2, 3, 4, 5, 6, 7, 7, 6, 5, 4, 3, 3, 2, 2, 2, 1]},
                {day: "Fri", values: [2, 2, 2, 2, 2, 1, 1, 1, 2, 3, 4, 5, 6, 6, 6, 5, 4, 4, 3, 3, 2, 2, 2, 1]},
                {day: "Sat", values: [1, 1, 2, 2, 2, 1, 1, 1, 1, 2, 3, 3, 4, 4, 4, 3, 3, 3, 2, 2, 2, 1, 1, 1]},
                {day: "Sun", values: [1, 1, 1, 1, 1, 1, 1, 1, 1, 2, 2, 3, 3, 3, 3, 3, 2, 2, 2, 2, 1, 1, 1, 1]},
            ],
            languageDistribution: [
                {label: "Spanish", value: 34},
                {label: "English", value: 28},
                {label: "Portuguese", value: 19},
                {label: "Japanese", value: 9},
                {label: "Korean", value: 5},
                {label: "Other", value: 5},
            ],
        };
    },
    computed: {
        currentPeriodData() {
            return this.allPeriodData[this.selectedPeriod];
        },
        performanceCards() {
            return this.currentPeriodData.performanceCards;
        },
        leadDistribution() {
            return this.currentPeriodData.leadDistribution;
        },
        enrollmentCards() {
            return this.currentPeriodData.enrollmentCards;
        },
        conversationSeries() {
            return this.currentPeriodData.conversationSeries;
        },
        topQuestions() {
            return this.currentPeriodData.topQuestions;
        },
        attentionItems() {
            return this.currentPeriodData.attentionItems;
        },
        conversationChartOptions() {
            return {
                chart: {type: "line", toolbar: {show: false}, zoom: {enabled: false}, foreColor: "#6b7280"},
                stroke: {curve: "smooth", width: [3, 2.5, 2.5], dashArray: [0, 6, 2]},
                colors: ["#3b82f6", "#0d9488", "#f59e0b"],
                grid: {borderColor: "#e5eaf2", strokeDashArray: 0, padding: {left: 6, right: 6, top: 4, bottom: 0}},
                xaxis: {
                    categories: this.currentPeriodData.conversationCategories,
                    labels: {show: true, trim: true},
                    axisTicks: {show: false},
                    axisBorder: {show: false},
                },
                yaxis: {labels: {formatter: (value) => Math.round(value)}, min: 0, tickAmount: 5},
                legend: {position: "top", horizontalAlign: "left", fontSize: "12px", markers: {radius: 6}},
                dataLabels: {enabled: false},
                tooltip: {shared: true},
            };
        },
        heatmapHourTicks() {
            return [
                {label: "0", column: 1},
                {label: "6", column: 7},
                {label: "12", column: 13},
                {label: "18", column: 19},
            ];
        },
        heatmapPeakLabel() {
            let peakValue = Number.NEGATIVE_INFINITY;
            let peakDay = "Mon";
            let peakHour = 0;

            this.heatmapRows.forEach((row) => {
                row.values.forEach((value, hour) => {
                    if (value > peakValue) {
                        peakValue = value;
                        peakDay = row.day;
                        peakHour = hour;
                    }
                });
            });

            return `${peakDay} ${String(peakHour).padStart(2, "0")}:00`;
        },
    },
    methods: {
        heatCellOpacity(value) {
            const min = 1;
            const max = 8;
            const normalized = (value - min) / (max - min);
            return (0.18 + normalized * 0.82).toFixed(2);
        },
        heatCellColor(value) {
            const palette = ["#f2f4f7", "#dce8fb", "#c7daf8", "#b0cdf6", "#8eb8f0", "#5e97e8", "#2f75d4", "#1f5ea8"];
            const index = Math.min(Math.max(value, 1), 8) - 1;
            return palette[index];
        },
    },
};
</script>

<template>
    <DashboardLayout title="Dashboard" subtitle="Your chatbot's performance at a glance">
        <section class="dashboard-page">
            <section class="dashboard-page__section">
                <div class="dsb-section-toolbar">
                    <div class="dashboard-page__section-headline">Chatbot Performance</div>
                    <div class="dsb-section-toolbar__right">
                        <div class="dsb-period-switcher">
                            <button v-for="p in periods" :key="p.value" type="button" class="dsb-period-btn" :class="{active: selectedPeriod === p.value}" @click="selectedPeriod = p.value">
                                {{ p.label }}
                            </button>
                        </div>
                        <button type="button" class="dsb-export-btn">
                            <PhDownloadSimple :size="14" weight="bold" />
                            Export
                        </button>
                    </div>
                </div>
                <div class="dashboard-page__stats">
                    <article v-for="card in performanceCards" :key="card.label" class="dashboard-page__stat-card">
                        <span class="dashboard-page__stat-label">{{ card.label }}</span>
                        <strong class="dashboard-page__stat-value" :class="`is-${card.tone}`">{{ card.value }}</strong>
                        <span class="dashboard-page__stat-note" :class="`is-${card.tone}`">{{ card.note }}</span>
                    </article>
                </div>

                <div class="dashboard-page__performance-grid">
                    <article class="dashboard-page__panel dashboard-page__panel--trend">
                        <header class="dashboard-page__panel-header">
                            <h2 class="dashboard-page__panel-title">Conversation Trend</h2>
                            <p class="dashboard-page__panel-subtitle">Last 30 days · Daily conversations, leads and enrollments</p>
                        </header>
                        <apexchart class="dashboard-page__chart dashboard-page__chart--line" type="line" height="248" :options="conversationChartOptions" :series="conversationSeries" />
                    </article>

                    <div class="dashboard-page__side-stack">
                        <article class="dashboard-page__panel">
                            <header class="dashboard-page__panel-header">
                                <h2 class="dashboard-page__panel-title">Lead Distribution</h2>
                                <p class="dashboard-page__panel-subtitle">Score-based classification</p>
                            </header>
                            <div class="dashboard-page__distribution-list">
                                <div v-for="item in leadDistribution" :key="item.label" class="dashboard-page__distribution-item">
                                    <span class="dashboard-page__distribution-label" :class="`is-${item.tone}`">{{ item.label }}</span>
                                    <div class="dashboard-page__distribution-track">
                                        <div class="dashboard-page__distribution-fill" :class="`is-${item.tone}`" :style="{width: `${item.percent}%`}" />
                                    </div>
                                    <span class="dashboard-page__distribution-value">{{ item.value }}</span>
                                    <span class="dashboard-page__distribution-percent">{{ item.percent }}%</span>
                                </div>
                            </div>
                        </article>

                        <article class="dashboard-page__panel">
                            <header class="dashboard-page__panel-header">
                                <h2 class="dashboard-page__panel-title">Average Lead Score</h2>
                                <p class="dashboard-page__panel-subtitle">AI-scored this period</p>
                            </header>
                            <div class="dashboard-page__score">
                                <strong>61</strong>
                                <span>previous period: 54</span>
                            </div>
                            <div class="dashboard-page__score-progress">
                                <div class="dashboard-page__score-progress-fill" style="width: 61%" />
                            </div>
                            <p class="dashboard-page__score-caption">System learns and improves each period</p>
                        </article>
                    </div>
                </div>
            </section>

            <section class="dashboard-page__section">
                <div class="dashboard-page__section-headline">Enrollment & Conversion</div>
                <div class="dashboard-page__enrollment-cards">
                    <article v-for="card in enrollmentCards" :key="card.label" class="dashboard-page__summary-card">
                        <span class="dashboard-page__summary-label">{{ card.label }}</span>
                        <strong class="dashboard-page__summary-value">{{ card.value }}</strong>
                        <span class="dashboard-page__summary-note">{{ card.note }}</span>
                    </article>
                </div>

                <div class="dashboard-page__conversion-grid">
                    <article class="dashboard-page__panel dashboard-page__panel--funnel">
                        <header class="dashboard-page__panel-header">
                            <h2 class="dashboard-page__panel-title">Conversion Funnel</h2>
                            <p class="dashboard-page__panel-subtitle">From first conversation to enrollment · This period</p>
                        </header>

                        <div class="dashboard-page__funnel-steps">
                            <div class="dashboard-page__funnel-step">
                                <strong>1,247</strong>
                                <span>Conversations</span>
                                <small>Chatbot started</small>
                            </div>
                            <div class="dashboard-page__funnel-step is-info">
                                <strong>312</strong>
                                <span>Leads</span>
                                <small>25% conversion</small>
                            </div>
                            <div class="dashboard-page__funnel-step is-success">
                                <strong>19</strong>
                                <span>Enrolled</span>
                                <small>6.1% of leads</small>
                            </div>
                        </div>

                        <div class="dashboard-page__funnel-notes">
                            <p><strong>Fastest to enroll:</strong> Japan avg. 5.2 days · Brazil avg. 9.1 days</p>
                            <p><strong>Best converting:</strong> Students who return 3+ times → 42% enroll rate</p>
                        </div>
                    </article>

                    <article class="dashboard-page__panel">
                        <header class="dashboard-page__panel-header">
                            <h2 class="dashboard-page__panel-title">Enrollment Trend</h2>
                            <p class="dashboard-page__panel-subtitle">Monthly enrollments · Last 12 months</p>
                        </header>
                        <apexchart class="dashboard-page__chart dashboard-page__chart--bar" type="bar" height="214" :options="enrollmentTrendOptions" :series="enrollmentTrendSeries" />

                        <div class="dashboard-page__trend-summary">
                            <div><strong>19</strong><span>This month</span></div>
                            <div><strong>156</strong><span>Year to date</span></div>
                            <div><strong>Sep</strong><span>Peak month</span></div>
                            <div><strong>+58%</strong><span>YoY growth</span></div>
                        </div>
                    </article>
                </div>
            </section>

            <section class="dashboard-page__section">
                <div class="dashboard-page__section-headline">Audience & Engagement</div>

                <article class="dashboard-page__panel dashboard-page__panel--map">
                    <header class="dashboard-page__panel-header">
                        <h2 class="dashboard-page__panel-title">Lead Source Map</h2>
                        <p class="dashboard-page__panel-subtitle">Country-based lead distribution · Bubble size = lead count</p>
                    </header>

                    <LeadSourceMap class="dashboard-page__map" :markers="mapBubbles" :center="[12, 50]" :zoom="2.15" :pitch="20" :bearing="-8" />

                    <div class="dashboard-page__map-footer">
                        <span>312 leads total · 40 countries</span>
                    </div>
                </article>

                <div class="dashboard-page__engagement-grid">
                    <article class="dashboard-page__panel">
                        <header class="dashboard-page__panel-header">
                            <h2 class="dashboard-page__panel-title">Activity by Day & Hour</h2>
                            <p class="dashboard-page__panel-subtitle">Conversation volume heatmap · Peak: Tuesday 2pm</p>
                        </header>

                        <div class="dashboard-page__heatmap">
                            <div class="dashboard-page__heatmap-hours">
                                <span class="dashboard-page__heatmap-hours-spacer" />
                                <span v-for="tick in heatmapHourTicks" :key="tick.label" class="dashboard-page__heatmap-hour-label" :style="{gridColumn: `${tick.column} / span 1`}">
                                    {{ tick.label }}
                                </span>
                            </div>

                            <div class="dashboard-page__heatmap-grid">
                                <template v-for="row in heatmapRows" :key="row.day">
                                    <span class="dashboard-page__heatmap-day">{{ row.day }}</span>
                                    <div
                                        v-for="(cell, index) in row.values"
                                        :key="`${row.day}-${index}`"
                                        class="dashboard-page__heatmap-cell"
                                        :style="{backgroundColor: heatCellColor(cell), opacity: heatCellOpacity(cell)}"
                                    />
                                </template>
                            </div>
                        </div>

                        <div class="dashboard-page__heatmap-meta">
                            <div class="dashboard-page__heatmap-scale">
                                <span>Low</span>
                                <i v-for="n in 6" :key="n" :style="{backgroundColor: heatCellColor(n + 1), opacity: heatCellOpacity(n + 1)}" />
                                <span>High</span>
                            </div>
                            <span class="dashboard-page__heatmap-peak">Peak: {{ heatmapPeakLabel }}</span>
                        </div>

                        <p class="dashboard-page__tip">Tip: Most leads arrive Tuesday - Friday between 10am - 4pm. Schedule follow-up calls during this window.</p>
                    </article>

                    <div class="dashboard-page__middle-stack">
                        <article class="dashboard-page__panel">
                            <header class="dashboard-page__panel-header">
                                <h2 class="dashboard-page__panel-title">Language Distribution</h2>
                                <p class="dashboard-page__panel-subtitle">Student conversation language</p>
                            </header>

                            <div class="dashboard-page__language-list">
                                <div v-for="item in languageDistribution" :key="item.label" class="dashboard-page__language-item">
                                    <span>{{ item.label }}</span>
                                    <div class="dashboard-page__language-track">
                                        <div class="dashboard-page__language-fill" :style="{width: `${item.value}%`}" />
                                    </div>
                                    <strong>{{ item.value }}%</strong>
                                </div>
                            </div>
                        </article>

                        <article class="dashboard-page__panel">
                            <header class="dashboard-page__panel-header">
                                <h2 class="dashboard-page__panel-title">Top Questions</h2>
                                <p class="dashboard-page__panel-subtitle">This period · Top 5</p>
                            </header>

                            <div class="dashboard-page__questions">
                                <div v-for="item in topQuestions" :key="item.label" class="dashboard-page__question-row">
                                    <span>{{ item.label }}</span>
                                    <strong>{{ item.value }}</strong>
                                </div>
                            </div>
                        </article>
                    </div>

                    <article class="dashboard-page__panel">
                        <header class="dashboard-page__panel-header">
                            <h2 class="dashboard-page__panel-title">Needs Attention</h2>
                            <p class="dashboard-page__panel-subtitle">Action recommended</p>
                        </header>

                        <div class="dashboard-page__attention-list">
                            <div v-for="item in attentionItems" :key="item.title" class="dashboard-page__attention-item" :class="`is-${item.tone}`">
                                <strong>{{ item.title }}</strong>
                                <span>{{ item.description }}</span>
                            </div>
                        </div>
                    </article>
                </div>
            </section>
        </section>
    </DashboardLayout>
</template>

<style scoped>
.dsb-section-toolbar {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 1rem;
    flex-wrap: wrap;
    margin-bottom: 0.5rem;
}

.dsb-section-toolbar__right {
    display: flex;
    align-items: center;
    gap: 0.75rem;
}

.dsb-period-switcher {
    display: flex;
    background: #f1f3f8;
    border-radius: 0.6rem;
    padding: 3px;
    gap: 2px;
}

.dsb-period-btn {
    padding: 5px 14px;
    border: none;
    background: transparent;
    border-radius: 0.45rem;
    font-size: 0.82rem;
    font-weight: 600;
    color: #64748b;
    cursor: pointer;
    transition: all 0.15s;
    white-space: nowrap;
}

.dsb-period-btn.active {
    background: #ffffff;
    color: #1e293b;
    box-shadow: 0 1px 4px rgba(15, 23, 42, 0.1);
}

.dsb-export-btn {
    display: inline-flex;
    align-items: center;
    gap: 6px;
    padding: 7px 14px;
    border: 1px solid #d9e2ef;
    border-radius: 0.6rem;
    background: #ffffff;
    color: #374151;
    font-size: 0.82rem;
    font-weight: 600;
    cursor: pointer;
    transition: background 0.15s;
}

.dsb-export-btn:hover {
    background: #f8fafc;
}
</style>
